import { lazy } from "react";
import { Route, Navigate } from "react-router-dom";
import { AppRoutes } from "@/infra/router";
import LazyPage from "@/infra/router/LazyPage";

const DashboardTodayPage = lazy(() => import("./DashboardTodayPage"));
const DashboardAnalysisPage = lazy(() => import("./DashboardAnalysisPage"));
const DashboardTherapyPlanPage = lazy(() => import("./DashboardTherapyPlanPage"));

export const dashboardRoutes = [
  <Route
    key={AppRoutes.Dashboard}
    element={<Navigate replace to={AppRoutes.DashboardToday} />}
    path={AppRoutes.Dashboard}
  />,
  <Route
    key={AppRoutes.DashboardToday}
    path={AppRoutes.DashboardToday}
    element={<LazyPage element={<DashboardTodayPage />} />}
  />,
  <Route
    key={AppRoutes.DashboardAnalysis}
    path={AppRoutes.DashboardAnalysis}
    element={<LazyPage element={<DashboardAnalysisPage />} />}
  />,
  <Route
    key={AppRoutes.DashboardTherapyPlan}
    path={AppRoutes.DashboardTherapyPlan}
    element={<LazyPage element={<DashboardTherapyPlanPage />} />}
  />,
];
